import {Col, FormControl, InputGroup, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import {Link} from "react-router-dom";
import DataTable from "react-data-table-component";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

const AdminOrders = () => {

    const [selectedRow, setSelectedRow] = useState();
    const [searchText, setSearchText] = useState("");
    const [pageSize, setPageSize] = useState(100000);
    const [orderItemList, setOrderItemList] = useState([]);
    const [orderListFiltered, setOrderListFiltered] = useState([]);

    useEffect(() => {
        ApiService.getAdminBasket(pageSize).then(basketData => {
            createOrderItem(basketData.basketBookDtos);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize]);

    useEffect(() => {
        if (searchText) {
            const filteredList = orderItemList.filter(order =>
                order.participantName?.toLowerCase().includes(searchText.toLowerCase()) ||
                order.participantSurname?.toLowerCase().includes(searchText.toLowerCase()) ||
                order.name?.toLowerCase().includes(searchText.toLowerCase()) ||
                order.surname?.toLowerCase().includes(searchText.toLowerCase()) ||
                order.mail?.toLowerCase().includes(searchText.toLowerCase())
            );
            setOrderListFiltered(filteredList);
        } else if (searchText === "") {
            setOrderListFiltered(orderItemList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);

    const createOrderItem = async (orderDataList) => {
        let orderList = [];

        for (let i = 0; i < orderDataList.length; i++) {
            let order = orderDataList[i];

            if (order.payed === true || order.status === "Deleted" || order.status === "Completed") {
                let orderItem = {
                    id: order.id,
                    status: order.status,
                    participantName: order.participantDto?.firstName ?? "",
                    participantSurname: order.participantDto?.lastName ?? "",
                    name: order.userInformation?.firstName,
                    surname: order.userInformation?.lastName,
                    mail: order.userInformation?.email,
                    date: DateTimeUtils.fromDateToLocalFormat(order.creationDate),
                    originalDate: new Date(order.creationDate), // Store the original date for sorting
                    total: order.total,
                };

                orderList.push(orderItem);
            }
        }

        setOrderItemList(orderList);
        setOrderListFiltered(orderList);
    };

    const columns = [
        {
            name: 'Nome',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Cognome',
            selector: row => row.surname,
            sortable: true,
        },
        {
            name: 'Mail',
            selector: row => row.mail,
            sortable: true,
        },
        {
            name: 'Data ordine',
            selector: row => row.originalDate, // Use originalDate for sorting
            format: row => row.date, // Format the date for display
            sortable: true,
            sortFunction: (a, b) => a.originalDate - b.originalDate, // Ensure proper date sorting
        },
        {
            name: 'Totale',
            selector: row => row.total,
            sortable: true,
        },
        {
            name: 'Stato',
            selector: row => row.status,
            sortable: true,
        },
        {
            cell: () => <Link className={'btn btn-sm btn-primary text-nowrap'} to={"admin-detail-order"} state={{from: (selectedRow && selectedRow.id)}}>Dettaglio</Link>,
            right: true,
        },
    ];

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back />
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 d-flex justify-content-between align-items-center'}>
                                <Row>
                                    <h2 className={'title'}>Ordini</h2>
                                    <InputGroup className='search-input w-100'>
                                        <FormControl
                                            type='text'
                                            placeholder='Search...'
                                            aria-label='Search'
                                            onChange={(value) => setSearchText(value.target.value)}
                                        />
                                    </InputGroup>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className={'mt-3'}>
                <Col xs={12}>
                    <DataTable
                        columns={columns}
                        data={orderListFiltered}
                        highlightOnHover
                        pagination
                        responsive
                        striped
                        paginationPerPage={25}
                        onChangePage={(page) => console.log(page)}
                        paginationRowsPerPageOptions={[25]}
                        onRowMouseEnter={(row) => {
                            console.log(row);
                            setSelectedRow(row);
                        }}
                        onChangeRowsPerPage={pageLength => {
                            console.log("PageSize: " + pageLength);
                            setPageSize(pageLength);
                        }}
                    />
                </Col>
            </Row>
        </>
    );
};

export default AdminOrders;
